import axios from 'axios'
import store from '@/store'

export default {

  async getBlocks () {
    try {
      let result = await axios.get(store.getters.getOpaApi + '/company/' + store.state.company.companyId)
      if (result.data && result.data.length) {
        return result.data[0]
      } else {
        return {error: true, data: null, msg: 'Erro ao obter bloqueios'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return { error: true, data: error, msg: 'Erro ao obter bloqueios'}
    }
  },

  async saveBlocks (blocks, block_address_navigation) {
    let data = {
      blocks: blocks,
      block_address_navigation: block_address_navigation 
    }
    try {
      let result = await axios.patch(store.getters.getOpaApi +'/company/' + store.state.company.Id, data)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao salvar bloqueios'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return { error: true, data: error, msg: 'Erro ao salvar bloqueios'}
    }
  }
}